// extracted by mini-css-extract-plugin
export var amountContainer = "gift2024-module--amountContainer--7c3cd";
export var amountInput = "gift2024-module--amountInput--ef9d6";
export var button = "gift2024-module--button--30111";
export var buttonContainer = "gift2024-module--buttonContainer--f098a";
export var container = "gift2024-module--container--32931";
export var descWrapper = "gift2024-module--descWrapper--d4cf9";
export var form = "gift2024-module--form--ae025";
export var formText = "gift2024-module--formText--e30b5";
export var highlight = "gift2024-module--highlight--d54e8";
export var image = "gift2024-module--image--ec047";
export var imageWrapper = "gift2024-module--imageWrapper--c25ea";
export var offering = "gift2024-module--offering--c7e82";
export var perText = "gift2024-module--perText--0a704";
export var periodSelect = "gift2024-module--periodSelect--55f02";
export var text = "gift2024-module--text--c96a9";
export var textInput = "gift2024-module--textInput--2a2f9";
export var title = "gift2024-module--title--9b0be";